import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip, useTheme } from '@mui/material';
import { renderIcon } from '../../../../core-ui/renderIcon';
export const ToolPane = ({ tool, tools, setTool }) => {
    const theme = useTheme();
    return (React.createElement(ToggleButtonGroup, { value: tool, orientation: "vertical", exclusive: true, onChange: (_, value) => setTool(value), sx: { backgroundColor: theme.palette.background.paper } }, tools.map((tool) => (React.createElement(Tooltip, { title: tool.label, arrow: true, placement: "right", enterDelay: 500, enterTouchDelay: 500 },
        React.createElement(ToggleButton, { key: tool.id, value: tool, "aria-label": tool.label }, renderIcon(tool.icon)))))));
};
//# sourceMappingURL=ToolPane.js.map